<template>
  <v-row dense>
    <v-col>
      <ReportHeading
        label="Грейди співробітників"
        :loading="loading"
        @update-report="getData"
      >
        <template v-slot:action>
          <DownloadFile
            location="xlsx"
            :params="reportData"
            filename="Грейди співробітників"
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
        </template>
        <template v-slot:filters>
          <GradesFilter
            v-model="filter"
            :loading="loading"
            @input="setFilter"
          />
        </template>
      </ReportHeading>
      <v-card>
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-footer
          :items-per-page="items.length"
          class="elevation-1"
          :loading="loading"
          height="63vh"
          no-data-text="Дані відсутні"
          loading-text="Завантаження данних"
          multi-sort
          :sort-by="['employee.title']"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.employee.title }}
              </td>
              <td>
                {{ item.project ? item.project.title : null }}
              </td>
              <td>
                {{ item.grade }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import GradesFilter from "./Filter.vue";
import * as reportsApi from "@/backend/reportsApi.js";
import ReportHeading from "@/components/ReportHeading.vue";
import DownloadFile from "@/components/DowloadFile.vue";
import { columnTypes, numberToString } from "@/helpers";

export default {
  components: {
    GradesFilter,
    ReportHeading,
    DownloadFile,
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      { text: "Виконавець", width: "60%", value: "employee.title" },
      { text: "Проект", width: "20%", value: "project", sortable: false },
      { text: "Грейд", value: "grade", width: "20%" },
    ],
    filter: {
      client: {
        id: null,
        title: "",
      },
      employee: {
        id: null,
        title: "",
      },
      date: "",
    },
  }),
  computed: {
    filterParams() {
      return {
        date: this.filter.date ? this.filter.date : null,
        clientId: this.filter.client ? this.filter.client.id : null,
        employeeId: this.filter.employee ? this.filter.employee.id : null,
      };
    },
    reportData() {
      return {
        columns: this.headers.map((h) => h.text),
        rows: this.items.map((i) => {
          return [
            i.employee.title,
            i.project?.title || "",
            numberToString(i.grade),
          ];
        }),
        columnTypes: [
          columnTypes.STRING,
          columnTypes.STRING,
          columnTypes.NUMBER,
        ],
      };
    },
  },
  watch: {
    filter() {
      this.getData();
    },
  },
  created() {
    this.filter.date = this.moment().format("YYYY-MM-DD");
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        this.items = await reportsApi.getEmployeesGrades(this.filterParams);
      } catch {
        this.$notifyWarning("Під час отримання данних сталася помилка");
      }
      this.loading = false;
    },
    setFilter(filter) {
      this.filter.client = filter.client;
      this.filter.employee = filter.employee;
      this.filter.date = filter.date;
    },
  },
};
</script>
